"use client";
import { getDictionary } from "@/dictionaries/dictionaries";

export default function Trans(file, keyJson, value) {
  let lang = "en-US";

  if (typeof window !== "undefined" && localStorage.getItem("lang")) {
    lang = localStorage.getItem("lang");
    if (lang === "en") {
      lang = "en-US";
    }
  } else if (typeof window !== "undefined" && navigator.language) {
    // Try to get exact match first
    let dict = getDictionary(navigator.language);
    
    if (dict) {
      // If exact match found, use it
      lang = navigator.language;
    } else {
      // If no exact match, try to find the first dictionary that matches the language prefix
      const languagePrefix = navigator.language.split('-')[0]; // Get 'es' from 'es-ES'
      const availableLanguages = ['en-US', 'es-AR', 'es-EC', 'es-MX', 'es-PE', 'es-UY', 'pt-BR'];
      
      // Find the first dictionary that starts with the language prefix
      const matchingLang = availableLanguages.find(availableLang => 
        availableLang.startsWith(languagePrefix)
      );
      
      if (matchingLang) {
        lang = matchingLang;
      }
      // If no match found at all, lang stays as "en-US" (default)
    }
  }

  let translations = getDictionary(lang);

  const getString = () => {
    let valueString;
    if (keyJson.includes(".")) {
      const keysJson = keyJson.split(".");
      valueString = translations;
      keysJson.forEach((key) => {
        if (valueString !== undefined) {
          valueString = valueString[key];
        }
      });
    } else {
      valueString = translations[keyJson];
    }

    if (valueString !== undefined) {
      if (Array.isArray(value)) {
        value.forEach((val, i) => {
          valueString = valueString.replace(`\${value${i}}`, val);
        });
      } else if (value) {
        valueString = valueString.replace(`\${value}`, value);
      }
    }

    return valueString;
  };

  const valueString = getString();

  if (valueString) {
    return valueString;
  }

  translations = file;
  return getString();
}
